import environment from "../environment";
import { DELETE, GET, PATCHForm, POST, POSTForm, PUT } from "./http.service";

const _endpoint = environment.STUDENT_ENDPOINT;
const _token = environment.TOKEN_KEY;

export const getStudentInfo = async () => {
  const response = await GET(`Student/profile`, localStorage.getItem(_token));
  return response;
};

export const deleteUserAccount = async () => {
  const response = await DELETE(`Profile`, localStorage.getItem(_token));
  return response;
};

export const getStudentCourses = async (requestBody) => {
  const response = await POST(
    `Course/student-courses`,
    requestBody,
    localStorage.getItem(_token)
  );
  return response;
};

export const getStudentRating = async () => {
  const response = await POST(
    `${_endpoint}/course/rating`,
    null,
    localStorage.getItem(_token)
  );
  return response;
};

export const getRequiredCourses = async () => {
  const response = await POST(
    `${_endpoint}/get/required-courses`,
    null,
    localStorage.getItem(_token)
  );
  return response;
};

export const updateUserInfo = async (requestBody) => {
  const response = await PUT(
    `Student/profile`,
    requestBody,
    localStorage.getItem(_token)
  );
  return response;
};

export const updateUserPassword = async (requestBody) => {
  const response = await PUT(
    `Profile/password`,
    requestBody,
    localStorage.getItem(_token)
  );
  return response;
};

export const updateUserProfileImage = async (requestBody) => {
  const response = await PATCHForm(
    `Student/profile/image`,
    requestBody,
    localStorage.getItem(_token)
  );
  return response;
};

export const addComment = async (requestBody) => {
  const response = await POST(
    `Review`,
    requestBody,
    localStorage.getItem(_token)
  );
  return response;
};

export const countinueYourEducation = async () => {
  const response = await GET(
    `Course/upcomming-course`,
    localStorage.getItem(_token)
  );
  return response;
};

export const LiveCourses = async () => {
  const response = await POST(
    `${_endpoint}/get-live-courses`,
    null,
    localStorage.getItem(_token)
  );
  return response;
};

export const courseAttend = async (slug) => {
  const response = await GET(
    `Course/${slug}/student-attendee`,
    localStorage.getItem(_token)
  );
  return response;
};

export const getSessionAssignment = async (id) => {
  const response = await GET(`SessionTask/${id}`, localStorage.getItem(_token));
  return response;
};

export const uploadAssignment = async (requestBody) => {
  const response = await POSTForm(
    `TaskAnswer`,
    requestBody,
    localStorage.getItem(_token)
  );
  return response;
};

export const addPayments = async (requestBody) => {
  const response = await POSTForm(
    `CourseRegistration/payment-receipt`,
    requestBody,
    localStorage.getItem(_token)
  );
  return response;
};

export const getLeaderboard = async () => {
  const response = await GET(
    `Course/distinguished-student`,
    localStorage.getItem(_token)
  );
  return response;
};
